@if (!!selectedHero() || headerState?.isBackButtonShown) {
  <div
    class="elements g-flex g-flex--align-center"
    [class.g-flex--space-between]="!selectedHero()">
    <div class="left-menu g-flex g-flex--align-center g-flex__item-fixed">
      @if (headerState?.isBackButtonShown) {
        <div
          class="btn-back g-flex__item-fixed g-flex g-flex--align-center g-flex--justify-center pointer"
          (click)="goBack()">
          <img
            class="btn-back__img"
            src="assets/images/ui/icons/other/left.png"
            alt="" />
        </div>
      }
    </div>

    @if (account) {
      <app-avatar
        class="g-flex__item-fixed"
        avatarType="tiny"
        [imagePath]="userAvatar ? userAvatar : 'assets/images/ui/guilds/account-avatar.avif'"
        [ngLevel]="selectedHero()?.ngLevel || 0"
        [routerLink]="[MAIN_ROUTES.MAIN, MAIN_ROUTES.ACCOUNT]">
      </app-avatar>

      <div
        class="g-flex__item g-flex-column g-flex--align-start margin-left-6"
        [class.content--with-life-chances]="!isShowBars && !!selectedHero()?.stats?.lifeChances">
        <div
          class="account-id g-flex g-flex--align-center gap-10 width-100-percent line-height-120 text-nowrap"
          [class.app-btn-tiny-small_font-size]="!!userName"
          [class.color-yellow-light]="!!userName"
          [class.text-shadow]="!!userName"
          [class.app-btn_font-size]="!userName"
          [class.color-nickname]="!userName">
          <!--          <img-->
          <!--            class="web3-auth pointer"-->
          <!--            [src]="-->
          <!--              isShowThunderbolt()-->
          <!--                ? '/assets/images/ui/icons/other/thunderbolt.png'-->
          <!--                : '/assets/images/ui/buttons/other/thunderbolt/disabled.png'-->
          <!--            "-->
          <!--            alt=""-->
          <!--            (click)="onSessionSettings()" />-->

          <div>Acc ID:</div>

          <div class="text-ellipsis">
            {{ accountFormatted }}
          </div>
        </div>

        @if (!!userName) {
          <div
            class="color-nickname app-btn_font-size text-ellipsis width-100-percent text-left line-height-120 text-nowrap">
            {{ userName }}
          </div>
        }

        @if (!!guild()) {
          <div class="guild-id g-flex g-flex--align-center gap-10 width-100-percent">
            <app-guild-avatar
              class="guild-avatar"
              type="small"
              [logoUrl]="guild()!.uri || 'assets/images/ui/guilds/guild-avatar.avif'"
              customWidth="40px"
              customHeight="40px" />

            @if (guild()!.name) {
              <div class="app-btn-tiny_font-size color-yellow-fire text-ellipsis">
                {{ guild()!.name }}
              </div>
            }
          </div>
        }
      </div>
    }

    @if (!!selectedHero() || isAbleToPvP) {
      <div class="notifications g-flex__item-fixed g-flex g-flex--align-center g-flex--justify-center g-flex--wrap">
        @if (isAbleToPvP) {
          <img
            class="account__wallet-icon"
            src="assets/images/ui/icons/other/pvp-points.png"
            alt=""
            (click)="onShowPvPDialog()" />
        }
        @if (selectedHero() && heroExpPerc() >= 100 && (selectedHero()?.stats?.level || 0) < 100) {
          <img
            class="account__wallet-icon"
            src="assets/images/ui/icons/notifications/level-up-small.png"
            alt=""
            (click)="onShowLevelUpDialog()" />
        }

        @if (selectedHero() && isAbleToClaimRewards) {
          <img
            class="account__wallet-icon"
            src="assets/images/ui/icons/notifications/reinforcement-small.png"
            alt=""
            (click)="onShowReinforcementDialog()" />
        }

        @if (selectedHero() && isNeedRepair) {
          <img
            class="account__wallet-icon"
            src="assets/images/ui/icons/notifications/repair-small.png"
            alt=""
            (click)="onShowRepairDialog()" />
        }
      </div>
    }

    @if (account && headerState?.isAccountAddressShown) {
      <div
        class="g-flex__item-fixed g-flex-column"
        (click)="buyTokens('sacra')">
        <app-balance
          class="color-positive-value"
          tokenType="sacra"
          size="tiny"
          [isReverse]="false"
          [balance]="Formatter.formatNumber(gameTokenBalance || 0)"
          [balanceUnformatted]="+gameTokenBalance"
          [isShowBalanceUsd]="true"
          balanceIconWidth="40px"
          balanceIconHeight="40px">
        </app-balance>

        <app-balance
          class="color-yellow-light"
          [tokenIconPath]="iconName"
          size="tiny"
          tokenType="s"
          [isReverse]="false"
          [balance]="networkTokenBalance"
          [balanceUnformatted]="networkTokenBalanceFormatted"
          [isShowBalanceUsd]="true"
          balanceIconWidth="40px"
          balanceIconHeight="40px">
        </app-balance>
      </div>
    }

    @if (!isHideMenuButton) {
      <div
        class="menu g-flex__item-fixed g-flex g-flex--align-center pointer"
        (click)="handleMenu()">
        <img
          class="menu__icon"
          src="assets/images/ui/icons/other/menu.png"
          alt="" />
      </div>
    }

    <div
      class="menu__border app-divider-scratches-border-v-medium-down no-action"
      [class.menu__border--show]="menuState.isOpen"></div>
  </div>
}

@if (selectedHero() || headerState?.isBackButtonShown) {
  <div
    class="border g-flex g-flex--justify-center"
    [class.border--show]="menuState.isOpen"
    [class.border--no-hero]="!selectedHero()">
    <img
      class="border__corner border__corner-left"
      src="assets/images/ui/menu/border-left-part-corner-left.avif"
      alt="" />

    <img
      class="menu-border"
      src="assets/images/ui/menu/border-left-part-expandable.avif"
      alt="" />

    <img
      class="menu-border corner-right"
      src="assets/images/ui/menu/border-left-part-corner-right.avif"
      alt="" />

    <img
      class="menu-center"
      src="assets/images/ui/menu/border-middle.avif"
      alt="" />

    <img
      class="menu-border corner-left"
      src="assets/images/ui/menu/border-right-part-corner-left.avif"
      alt="" />

    <img
      class="menu-border"
      src="assets/images/ui/menu/border-right-part-expandable.avif"
      alt="" />

    <div
      class="border-right"
      [class.border-right--show]="menuState.isOpen"></div>

    <img
      class="border__corner border__corner-right"
      src="assets/images/ui/menu/border-right-part-corner-right.avif"
      alt="" />
  </div>
}

@if (!menuState.isOpen && !isHideMenuButtons) {
  <div
    class="btns gap-10"
    [class.btns--no-bars]="!isShowBars || !selectedHero()">
    <div
      class="menu-camp"
      [class.menu-camp--disabled]="!selectedHero()"
      (click)="openCamp()"></div>

    <div
      class="menu-bottle"
      [class.menu-bottle--disabled]="!selectedHero()"
      (click)="openBottlesDialog()"></div>

    <div
      class="menu-help"
      [class]="isHasTutorial ? 'menu-help-active' : 'menu-help'"
      (click)="openTutorial()"></div>
  </div>
}

@if (!menuState.isOpen && !isHideMenuButtons) {
  <div
    class="bar-bg"
    [class.bar-bg--no-bars]="!isShowBars || !selectedHero()"></div>
}

<div
  class="content g-flex-column"
  [class.content--no-hero]="!selectedHero()"
  [class.content--show]="menuState.isOpen">
  <div
    class="content__items g-flex--justify-center"
    [class.g-flex-column]="selectedHero()"
    [class.gap-20]="selectedHero()"
    [class.g-flex]="!selectedHero()">
    <div class="buttons g-flex-column g-flex--align-center g-flex--justify-center">
      <button
        class="buttons__item app-btn-red-huge-1 btn-settings g-flex g-flex--align-center pointer"
        (click)="openSettings()">
        <img
          class="buttons__item-icon"
          src="assets/images/ui/icons/other/settings.png"
          alt="" />
        {{ 'menu.buttons.settings' | translate }}
      </button>

      <button
        class="buttons__item app-btn-red-huge-1 btn-settings g-flex g-flex--align-center pointer"
        (click)="swapCoins()">
        <img
          class="buttons__item-icon"
          src="assets/images/ui/icons/other/marketplace.png"
          alt="" />
        {{ 'menu.buttons.swap-tokens' | translate }}
      </button>

      <button
        class="buttons__item app-btn-red-huge-1 g-flex g-flex--align-center pointer"
        (click)="openTransform()">
        <img
          class="buttons__item-icon g-flex__item-fixed"
          src="assets/images/ui/icons/other/transmutation.png"
          alt="" />
        {{ 'menu.buttons.transmutation' | translate }}
      </button>

      <button
        class="btn-top-list buttons__item app-btn-red-huge-1 g-flex g-flex--align-center pointer"
        (click)="isSonicChain() ? openLeaderboard() : openTopList()">
        <img
          class="buttons__item-icon g-flex__item-fixed"
          src="assets/images/ui/icons/other/top-list.png"
          alt="" />
        {{ isSonicChain() ? ('menu.buttons.leaderboard' | translate) : ('menu.buttons.top-list' | translate) }}
      </button>
    </div>
  </div>
</div>

@if (!!selectedHero() && heroAttributes && isShowBars) {
  <div
    class="bar g-flex g-flex--space-between"
    [class.bar--show]="menuState.isOpen">
    <app-bar-stat
      barType="hp"
      size="menu"
      [isShowPoint]="false"
      [percentageValue]="(selectedHero()?.stats?.life || 0) / heroAttributes.life">
    </app-bar-stat>

    <app-bar-stat
      barType="mp"
      size="menu"
      [isShowPoint]="false"
      [isRotated]="true"
      [percentageValue]="(selectedHero()?.stats?.mana || 0) / heroAttributes.mana">
    </app-bar-stat>
  </div>
}

@if (headerState?.isBackButtonShown) {
  <div
    class="bg"
    [class.bg--show]="menuState.isOpen"
    [class.bg--no-hero]="!selectedHero()"></div>
}
